import { getFlightMarkup } from "app/services/AdminServices/bookingService";
import React, { useEffect, useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";

export default function ReturnFareSummary({
  review,
  values,
  getTotalTax,
  getBaseFare,
  calculateSSRAmount,
}) {
  const totalFareHandler = (fare, pax) => {
    const adultTax = Number(fare?.ADULT?.fC?.TF * pax.ADULT) || 0;
    const childTax = Number(fare?.CHILD?.fC?.TF * pax.CHILD) || 0;
    const infantTax = Number(fare?.INFANT?.fC?.TF * pax.INFANT) || 0;
    const totalFare = adultTax + childTax + infantTax;
    return totalFare;
  };

  const userMarkUp = values?.userMarkup != null ? values?.userMarkup : 0;
  const adminMarkup = values?.adminMarkup != null ? values?.adminMarkup : 0;

  return (
    <div>
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Row>
          <Col sm={3}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="first">Onward Flight Fare</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">Return Flight Fare</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={9}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Row>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    Base Fare
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{ justifyContent: "flex-end", display: "flex" }}
                  >
                    {review?.tripInfos[0].totalPriceList.map(
                      (subItem, index) => {
                        return (
                          <Row key={index}>
                            {subItem.fd.ADULT && (
                              <div>
                                <div
                                  style={{
                                    fontSize: 15,
                                    fontWeight: "bold",
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  Adult(s) ({review?.searchQuery.paxInfo.ADULT}{" "}
                                  x ₹{" "}
                                  {Number(subItem.fd.ADULT?.fC?.BF).toFixed(2)})
                                </div>
                                <div
                                  style={{
                                    fontSize: 14,
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  ₹{" "}
                                  {Number(
                                    subItem.fd.ADULT?.fC?.BF *
                                      review?.searchQuery.paxInfo.ADULT
                                  ).toFixed(2)}
                                </div>
                              </div>
                            )}

                            {subItem.fd.CHILD && (
                              <div>
                                <div
                                  style={{
                                    fontSize: 15,
                                    fontWeight: "bold",
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  Child(s) ({review?.searchQuery.paxInfo.CHILD}{" "}
                                  x ₹{" "}
                                  {Number(subItem.fd.CHILD?.fC?.BF).toFixed(2)})
                                </div>
                                <div
                                  style={{
                                    fontSize: 14,
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  ₹{" "}
                                  {Number(
                                    subItem.fd.CHILD?.fC?.BF *
                                      review?.searchQuery.paxInfo.CHILD
                                  ).toFixed(2)}
                                </div>
                              </div>
                            )}
                            {subItem.fd.INFANT && (
                              <div>
                                <div
                                  style={{
                                    fontSize: 15,
                                    fontWeight: "bold",
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  Infant(s) (
                                  {review?.searchQuery.paxInfo.INFANT} x ₹{" "}
                                  {Number(subItem.fd.INFANT?.fC?.BF).toFixed(2)}
                                  )
                                </div>
                                <div
                                  style={{
                                    fontSize: 14,
                                    justifyContent: "center",
                                    display: "flex",
                                  }}
                                >
                                  ₹{" "}
                                  {Number(
                                    subItem.fd.INFANT?.fC?.BF *
                                      review?.searchQuery.paxInfo.INFANT
                                  ).toFixed(2)}
                                </div>
                              </div>
                            )}
                          </Row>
                        );
                      }
                    )}
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    Total Base Fare
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    ₹{" "}
                    {Number(
                      getBaseFare(
                        review?.tripInfos[0].totalPriceList[0].fd,
                        review?.searchQuery.paxInfo
                      )
                    ).toFixed(2)}
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    Total Tax Fare
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    ₹{" "}
                    {Number(
                      getTotalTax(
                        review?.tripInfos[0].totalPriceList[0].fd,
                        review?.searchQuery.paxInfo
                      ) + userMarkUp
                    ).toFixed(2)}
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    Handling Charge
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    ₹ {parseFloat(values?.adminMarkup).toFixed(2)}
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    SSR Amount
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    ₹{" "}
                    {Number(calculateSSRAmount(values?.pax?.onward)).toFixed(2)}
                  </Col>
                </Row>
                <Row>
                  <div
                    style={{
                      width: "100%",
                      float: "left",
                      marginTop: "11px",
                    }}
                  >
                    <div
                      className="text-primary"
                      style={{ borderBottom: "1px solid" }}
                    ></div>
                  </div>
                </Row>
                <Row
                  // className="bg-primary text-white"
                  style={{ marginTop: 5, marginLeft: 1, marginRight: 1 }}
                >
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    Total
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    ₹{" "}
                    {Number(
                      totalFareHandler(
                        review?.tripInfos[0].totalPriceList[0].fd,
                        review?.searchQuery.paxInfo
                      ) +
                        userMarkUp +
                        adminMarkup +
                        calculateSSRAmount(values?.pax?.onward)
                    ).toFixed(2)}
                  </Col>
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <Row>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    Base Fare
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{ justifyContent: "flex-end", display: "flex" }}
                  >
                    {review?.tripInfos[1].totalPriceList.map(
                      (subItem, index) => {
                        return (
                          <Row key={index}>
                            {subItem.fd.ADULT && (
                              <div>
                                <div
                                  style={{
                                    fontSize: 15,
                                    fontWeight: "bold",
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  Adult(s) ({review?.searchQuery.paxInfo.ADULT}{" "}
                                  x ₹{" "}
                                  {Number(subItem.fd.ADULT?.fC?.BF).toFixed(2)})
                                </div>
                                <div
                                  style={{
                                    fontSize: 14,
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  ₹{" "}
                                  {Number(
                                    subItem.fd.ADULT?.fC?.BF *
                                      review?.searchQuery.paxInfo.ADULT
                                  ).toFixed(2)}
                                </div>
                              </div>
                            )}

                            {subItem.fd.CHILD && (
                              <div>
                                <div
                                  style={{
                                    fontSize: 15,
                                    fontWeight: "bold",
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  Child(s) ({review?.searchQuery.paxInfo.CHILD}{" "}
                                  x ₹{" "}
                                  {Number(subItem.fd.CHILD?.fC?.BF).toFixed(2)})
                                </div>
                                <div
                                  style={{
                                    fontSize: 14,
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  ₹{" "}
                                  {Number(
                                    subItem.fd.CHILD?.fC?.BF *
                                      review?.searchQuery.paxInfo.CHILD
                                  ).toFixed(2)}
                                </div>
                              </div>
                            )}
                            {subItem.fd.INFANT && (
                              <div>
                                <div
                                  style={{
                                    fontSize: 15,
                                    fontWeight: "bold",
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  Infant(s) (
                                  {review?.searchQuery.paxInfo.INFANT} x ₹{" "}
                                  {Number(subItem.fd.INFANT?.fC?.BF).toFixed(2)}
                                  )
                                </div>
                                <div
                                  style={{
                                    fontSize: 14,
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  ₹{" "}
                                  {Number(
                                    subItem.fd.INFANT?.fC?.BF *
                                      review?.searchQuery.paxInfo.INFANT
                                  ).toFixed(2)}
                                </div>
                              </div>
                            )}
                          </Row>
                        );
                      }
                    )}
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    Total Base Fare
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    ₹{" "}
                    {Number(
                      getBaseFare(
                        review?.tripInfos[1].totalPriceList[0].fd,
                        review?.searchQuery.paxInfo
                      )
                    ).toFixed(2)}
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    Total Tax Fare
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    ₹{" "}
                    {Number(
                      getTotalTax(
                        review?.tripInfos[1].totalPriceList[0].fd,
                        review?.searchQuery.paxInfo
                      ) + userMarkUp
                    ).toFixed(2)}
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    Handling Charge
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    ₹ {parseFloat(adminMarkup).toFixed(2)}
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    SSR Amount
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    ₹{" "}
                    {Number(calculateSSRAmount(values?.pax?.return)).toFixed(2)}
                  </Col>
                </Row>
                <Row>
                  <div
                    style={{
                      width: "100%",
                      float: "left",
                      marginTop: "11px",
                    }}
                  >
                    <div
                      className="text-primary"
                      style={{ borderBottom: "1px solid" }}
                    ></div>
                  </div>
                </Row>
                <Row style={{ marginTop: 5, marginLeft: 1, marginRight: 1 }}>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    Total
                  </Col>
                  <Col
                    xs={6}
                    md={6}
                    lg={6}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    ₹{" "}
                    {Number(
                      totalFareHandler(
                        review?.tripInfos[1].totalPriceList[0].fd,
                        review?.searchQuery.paxInfo
                      ) +
                        userMarkUp +
                        adminMarkup +
                        calculateSSRAmount(values?.pax?.return)
                    ).toFixed(2)}
                  </Col>
                </Row>
              </Tab.Pane>
              <Row>
                <div
                  style={{
                    width: "100%",
                    float: "left",
                    marginTop: "11px",
                  }}
                >
                  <div
                    className="text-primary"
                    style={{ borderBottom: "1px solid" }}
                  ></div>
                </div>
              </Row>
              <Row
                className="bg-primary text-white"
                style={{ marginTop: 5, marginLeft: 1, marginRight: 1 }}
              >
                <Col
                  xs={6}
                  md={6}
                  lg={6}
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                  }}
                >
                  Total Amount
                </Col>
                <Col
                  xs={6}
                  md={6}
                  lg={6}
                  style={{
                    justifyContent: "flex-end",
                    display: "flex",
                    fontSize: 15,
                    fontWeight: "bold",
                  }}
                >
                  ₹{" "}
                  {Number(
                    // totalFareHandler(
                    review?.totalPriceInfo.totalFareDetail.fC.TF +
                      userMarkUp * 2 +
                      adminMarkup * 2 +
                      calculateSSRAmount(values?.pax?.onward) +
                      calculateSSRAmount(values?.pax?.return)
                  ).toFixed(2)}
                </Col>
              </Row>
              <Row className="text-black">
                <Col
                  xs={6}
                  md={6}
                  lg={6}
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                  }}
                >
                  Discount
                </Col>
                <Col
                  xs={6}
                  md={6}
                  lg={6}
                  style={{
                    justifyContent: "flex-end",
                    display: "flex",
                    fontSize: 15,
                    fontWeight: "bold",
                  }}
                >
                  ₹ -{" "}
                  {Number(
                    review?.totalPriceInfo.totalFareDetail?.afC?.NCM?.OT
                  ).toFixed(2)}
                </Col>
                <Col
                  xs={6}
                  md={6}
                  lg={6}
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                  }}
                >
                  TDS Amount
                </Col>
                <Col
                  xs={6}
                  md={6}
                  lg={6}
                  style={{
                    justifyContent: "flex-end",
                    display: "flex",
                    fontSize: 15,
                    fontWeight: "bold",
                  }}
                >
                  ₹ +{" "}
                  {Math.abs(
                    review?.totalPriceInfo.totalFareDetail?.afC?.NCM?.TDS
                  ).toFixed(2)}
                </Col>
              </Row>

              <Row
                className="text-black"
                style={{
                  backgroundColor: "gray",
                  marginTop: 5,
                  marginLeft: 1,
                  marginRight: 1,
                }}
              >
                <Col
                  xs={6}
                  md={6}
                  lg={6}
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                  }}
                >
                  Net Amount
                </Col>
                <Col
                  xs={6}
                  md={6}
                  lg={6}
                  style={{
                    justifyContent: "flex-end",
                    display: "flex",
                    fontSize: 15,
                    fontWeight: "bold",
                  }}
                >
                  ₹{" "}
                  {Number(
                    // totalFareHandler(
                    review?.totalPriceInfo.totalFareDetail.fC.NF +
                      // userFlightMarkup +
                      adminMarkup * 2 +
                      calculateSSRAmount(values?.pax?.onward) +
                      calculateSSRAmount(values?.pax?.return)
                  ).toFixed(2)}
                </Col>
              </Row>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
}
